import React from 'react'
import VisionAndMessage from '../VisionComponents/VisionAndMessage'
import OurPartners from '../VisionComponents/OurPartners'


function Vision() {
    return (
        <>
            <div className="flex flex-col mt-20 gap-10">
                <VisionAndMessage />
                <OurPartners />
            </div>
        </>
    )
}

export default Vision